import React, { useState, useEffect } from 'react';
import API_BASE_URL from"../Config/config";
import {
  Container,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Chip,
  CircularProgress,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  Checkbox,
  ListItemText,
} from '@mui/material';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { api } from "../context/AuthContext";
import { Visibility, Description, PictureAsPdf, People, Search, FilterList, Work as WorkIcon, NavigateNext, NavigateBefore } from '@mui/icons-material';
import { viewResume } from '../services/fileService';
import { Pagination, Avatar, Menu, MenuItem } from '@mui/material';

const BACKEND_URL = API_BASE_URL;

function JobApplications() {
  const { jobId } = useParams();
  const [applications, setApplications] = useState([]);
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalApplications, setTotalApplications] = useState(0);

  // Filter Logic
  const location = useLocation();
  const [activeFilter, setActiveFilter] = useState(location.state?.filter || 'All');
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);

  const [searchTerm, setSearchTerm] = useState('');


  const [educationFilter, setEducationFilter] = useState([]);
  const [experienceFilter, setExperienceFilter] = useState([]);
  const [skillsFilter, setSkillsFilter] = useState([]);

  const [jobAppliedFilter, setJobAppliedFilter] = useState([]);
  const [passedOutYearFilter, setPassedOutYearFilter] = useState([]);

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleFilterSelect = (status) => {
    setActiveFilter(status);
    handleFilterClose();
    setPage(1);
  };
  const normalize = (value) => String(value ?? '').toLowerCase().trim();

  const handleMultiSelectChange = (setter) => (event) => {
    const value = event.target.value;
    setter(typeof value === 'string' ? value.split(',') : value);
    setPage(1);
  };

  const clearAdvancedFilters = () => {
    setPassedOutYearFilter([]);
    setExperienceFilter([]);
    setSkillsFilter([]);
    setEducationFilter([]);
    setJobAppliedFilter([]);
    setPage(1);
  };

  const passedOutYearOptions = ['2026', '2025', '2024', '2023', '2022', '2021'];
  const experienceOptions = ['0-1 Years', '1-3 Years', '3-5 Years', '5-8 Years', '8+ Years'];
  const educationOptions = ['B.Tech', 'M.Tech', 'BCA', 'MCA', 'MBA', 'Diploma', 'Any Graduate'];
  const skillOptions = [
    'Java',
    'Python',
    'React',
    'Node.js',
    'AWS',
    'SQL',
    'DevOps',
    'Spring Boot',
    'Hibernate',
    'JavaScript',
    'TypeScript',
    'Angular',
    'Vue.js',
    'Next.js',
    'Express.js',
    'MongoDB',
    'PostgreSQL',
    'MySQL',
    'Redis',
    'Docker',
    'Kubernetes',
    'Terraform',
    'Jenkins',
    'Git',
    'GitHub',
    'Linux',
    'Microservices',
    'REST API',
    'GraphQL',
    'Kafka',
    'RabbitMQ',
    'CI/CD',
    'Azure',
    'GCP',
    'Flutter',
    'Dart',
    'Firebase',
    'C',
    'C++',
    'C#',
    '.NET',
    'PHP',
    'Laravel',
    'Go',
    'Rust',
    'Machine Learning',
    'AI',
    'Data Science',
    'TensorFlow',
    'PyTorch',
    'OpenCV',
    'Selenium',
    'Manual Testing',
    'Automation Testing',
    'Cyber Security',
    'Power BI',
    'Tableau'
  ];


  const jobAppliedOptions = Array.from(
    new Set(applications.map((a) => a.job_title).filter(Boolean))
  );

  useEffect(() => {
    if (location.state && location.state.filter && location.state.fromDashboard) {
      if (location.state.filter.toLowerCase() !== activeFilter.toLowerCase()) {
        setActiveFilter(location.state.filter);
        // Reset the flag so manual changes are preserved
        navigate(location.pathname, { state: { ...location.state, fromDashboard: false }, replace: true });
      }
    }
  }, [location.state, activeFilter, navigate, location.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    async function fetchData() {
      try {
        const [jobRes, appsRes] = await Promise.all([
          jobId ? api.get(`/jobs/${jobId}`) : Promise.resolve({ data: null }),
        ]);

        setJob(jobRes.data);

        const params = new URLSearchParams();
        params.set('page', String(page));
        params.set('limit', '50');

        if (jobId) {
          params.set('jobId', jobId);
        } else {
          if (activeFilter && activeFilter.toLowerCase() !== 'all') {
            params.set('filter', activeFilter);
          }

          if (searchTerm?.trim()) {
            params.set('search', searchTerm.trim());
          }

          if (passedOutYearFilter.length) {
            params.set('passedOutYear', passedOutYearFilter.join(','));
          }

          if (experienceFilter.length) {
            params.set('experience', experienceFilter.join(','));
          }

          if (skillsFilter.length) {
            params.set('skills', skillsFilter.join(','));
          }

          if (educationFilter.length) {
            params.set('education', educationFilter.join(','));
          }

          if (jobAppliedFilter.length) {
            params.set('jobApplied', jobAppliedFilter.join(','));
          }
        }

        const response = jobId
          ? await api.get(`/applications/admin?${params.toString()}`)
          : await api.get(`/applications/admin?${params.toString()}`);

        const appsData =
          Array.isArray(response.data?.applications)
            ? response.data.applications
            : Array.isArray(response.data?.applications?.rows)
              ? response.data.applications.rows
              : Array.isArray(response.data?.rows)
                ? response.data.rows
                : Array.isArray(response.data)
                  ? response.data
                  : [];

        console.log("APPLICATION API RESPONSE:", response.data);
        console.log("PARSED APPS:", appsData);

        setApplications(appsData);
        setTotalPages(response.data?.totalPages || 1);
        setTotalApplications(response.data?.total ?? appsData.length ?? 0);
      } catch (error) {
        console.error('Failed to fetch applications:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [
    jobId,
    page,
    activeFilter,
    searchTerm,
    passedOutYearFilter,
    experienceFilter,
    skillsFilter,
    educationFilter,
    jobAppliedFilter,
  ]);

  // Filtered Data logic inside JobApplications.js
  const displayedApps = Array.isArray(applications)
    ? applications.filter((app) => {
        const status = normalize(app.status);

        const filterMap = {
          'technical interview cancelled': 'technical_cancelled',
          'hr interview cancelled': 'hr_cancelled',
        };

        const normalizedFilter =
          filterMap[activeFilter.toLowerCase()] ||
          activeFilter.toLowerCase().replace(/\s+/g, '_');

        const matchesStatus =
          activeFilter.toLowerCase() === 'all' ||
          status.includes(normalizedFilter) ||
          (activeFilter.toLowerCase() === 'pending' &&
            (status === 'pending' || status === 'pending_review')) ||
          (activeFilter.toLowerCase() === 'interview scheduled' &&
            status.includes('scheduled'));
const search = normalize(searchTerm);

const educationValue = normalize(app.application_education || app.education || '');
const experienceValue = normalize(app.application_experience || app.experience || '');
const skillsValue = normalize(app.candidate_skills || app.skills || '');
const passedOutYearValue = normalize(
  app.candidate_passed_out_year ||
  app.passed_out_year ||
  app.pass_out_year ||
  app.year_of_passing ||
  ''
);
const jobTitleValue = normalize(app.job_title || '');
const candidateNameValue = normalize(`${app.first_name || ''} ${app.last_name || ''}`);
const emailValue = normalize(app.email || '');
const statusValue = normalize(app.status || '');

const matchesSearch =
  !search ||
  candidateNameValue.includes(search) ||
  emailValue.includes(search) ||
  jobTitleValue.includes(search) ||
  statusValue.includes(search) ||
  educationValue.includes(search) ||
  experienceValue.includes(search) ||
  skillsValue.includes(search) ||
  passedOutYearValue.includes(search);

const matchesEducation =
  educationFilter.length === 0 ||
  educationFilter.some((item) => {
    const selected = normalize(item);

    if (!educationValue) return false;

    if (selected === 'b.tech' || selected === 'btech') {
      return (
        educationValue.includes('be') ||
        educationValue.includes('b.e') ||
        educationValue.includes('btech') ||
        educationValue.includes('b.tech') ||
        educationValue.includes('bachelor of technology') ||
        educationValue.includes('bachelor of engineering')
      );
    }

    if (selected === 'm.tech' || selected === 'mtech') {
      return (
        educationValue.includes('me') ||
        educationValue.includes('m.e') ||
        educationValue.includes('mtech') ||
        educationValue.includes('m.tech') ||
        educationValue.includes('master of technology') ||
        educationValue.includes('master of engineering')
      );
    }

    if (selected === 'bca') {
      return educationValue.includes('bca') || educationValue.includes('bachelor of computer applications');
    }

    if (selected === 'mca') {
      return educationValue.includes('mca') || educationValue.includes('master of computer applications');
    }

    if (selected === 'mba') {
      return educationValue.includes('mba') || educationValue.includes('master of business administration');
    }

    if (selected === 'diploma') {
      return educationValue.includes('diploma');
    }

    if (selected === 'any graduate') {
      return (
        educationValue.includes('graduate') ||
        educationValue.includes('degree') ||
        educationValue.includes('bachelor')
      );
    }

    return educationValue.includes(selected);
  });

const getExperienceYears = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const match = String(value).trim().match(/(\d+(\.\d+)?)/);
  return match ? Number(match[1]) : null;
};

const experienceYears = getExperienceYears(app.application_experience || app.experience);

const matchesExperience =
  experienceFilter.length === 0 ||
  experienceFilter.some((item) => {
    const label = normalize(item);

    if (experienceYears === null) return false;

    if (label === '0-1 years') return experienceYears >= 0 && experienceYears <= 1;
    if (label === '1-3 years') return experienceYears >= 1 && experienceYears <= 3;
    if (label === '3-5 years') return experienceYears >= 3 && experienceYears <= 5;
    if (label === '5-8 years') return experienceYears >= 5 && experienceYears <= 8;
    if (label === '8+ years') return experienceYears >= 8;

    return normalize(String(experienceYears)) === label;
  });

const matchesSkills =
  skillsFilter.length === 0 ||
  skillsFilter.some((item) => normalize(skillsValue).includes(normalize(item)));

const matchesJobApplied =
  jobAppliedFilter.length === 0 ||
  jobAppliedFilter.some((item) => jobTitleValue.includes(normalize(item)));

const matchesPassedOutYear =
  passedOutYearFilter.length === 0 ||
  passedOutYearFilter.some((item) => passedOutYearValue.includes(normalize(item)));

        return (
          matchesStatus &&
          matchesSearch &&
          matchesEducation &&
          matchesExperience &&
          matchesSkills &&
          matchesJobApplied &&
          matchesPassedOutYear
        );
      })
    : [];



  function getStatusColor(status) {
    const s = status?.toLowerCase() || '';

    // Exact colors from the image design
    if (s.includes('selected')) return { bg: '#ebfbee', text: '#2f855a' }; // Light green
    if (s.includes('offer released')) return { bg: '#ebf8ff', text: '#2b6cb0' }; // Light blue
    if (s.includes('terminated')) return { bg: '#fff5f5', text: '#c53030' }; // Light red
    if (s.includes('hr scheduled') || s.includes('hr_scheduled') || s.includes('ai_hr_interview') || s.includes('hr_l2_interview')) return { bg: '#faf5ff', text: '#6b46c1' }; // Light purple
    if (s.includes('technical cancelled') || s.includes('technical_cancelled')) return { bg: '#fffaf0', text: '#c05621' }; // Light orange
    if (s.includes('ai coding scheduled')) return { bg: '#fffff0', text: '#b7791f' }; // Light yellow

    // Map existing statuses to these if they differ
    if (s.includes('pending')) return { bg: '#fff8e1', text: '#f57f17' };
    if (s.includes('shortlisted')) return { bg: '#e3f2fd', text: '#1976d2' };
    if (s.includes('rejected')) return { bg: '#ffebee', text: '#d32f2f' };
    if (s.includes('completed')) return { bg: '#e0f2f1', text: '#4338CA' };
    if (s.includes('scheduled')) return { bg: '#e3f2fd', text: '#1976d2' };

    return { bg: '#f5f5f5', text: '#616161' }; // Grey default
  }

  const getAvatarColor = (name) => {
    const colors = ['#00695c', '#42a5f5', '#9575cd', '#ffa726', '#66bb6a', '#ef5350', '#ec407a'];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };

  const getInitials = (firstName, lastName) => {
    return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();
  };

  const getFileUrl = (filePath, isCoverLetter = false) => {
    if (!filePath) return '#';
    if (filePath.startsWith('http')) return filePath;
    let filename = filePath.split(/[\\/]/).pop();
    const type = isCoverLetter ? 'cover_letter' : 'resume';
    return `${BACKEND_URL}/api/applications/resume/${filename}?type=${type}`;
  };

  const formatStatus = (status) => {
    if (!status) return "";
    if (status === "ai_coding_scheduled") return "AI Coding Assessment Scheduled";
    return status.replace(/_/g, " ").replace(/\s+/g, " ").trim().replace(/\b\w/g, c => c.toUpperCase());
  };

  if (loading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}><CircularProgress /></Box>;
  }

  return (
    <Container maxWidth={false} sx={{ py: 4, px: { md: 6 } }}>
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
        <Typography variant="h4" sx={{ color: "#4F46E5", fontWeight: "bold" }}>
          All Job Applications
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <TextField
            placeholder="Search by name, email, job..."
            size="small"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setPage(1);
            }}
            sx={{
              width: 350,
              '& .MuiOutlinedInput-root': {
                borderRadius: '10px',
                bgcolor: 'white',
                '& fieldset': { borderColor: '#e2e8f0' },
                '&:hover fieldset': { borderColor: '#cbd5e0' },
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search sx={{ color: '#a0aec0', fontSize: 20 }} />
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="outlined"
            startIcon={<FilterList />}
            onClick={handleFilterClick}
            sx={{
              textTransform: 'none',
              fontWeight: 'bold',
              color: '#4F46E5',
              borderColor: '#4F46E5',
              borderRadius: '8px',
              height: '40px',
              '&:hover': { borderColor: '#4338CA', bgcolor: 'rgba(79,70,229,0.04)' }
            }}
          >
            {activeFilter.toLowerCase() === 'all' ? 'Filters' : activeFilter.charAt(0).toUpperCase() + activeFilter.slice(1)}
          </Button>
          <Menu
            anchorEl={filterAnchorEl}
            open={Boolean(filterAnchorEl)}
            onClose={handleFilterClose}
          >
            {[
              'All',
              'Pending',
              'Shortlisted',
              'Selected',
              'Offer Released',
              'Rejected',
              'Terminated',
              'Completed',
              'Interview Scheduled',
              'Technical Interview Cancelled',
              'HR Interview Cancelled',
            ].map((status) => (
              <MenuItem
                key={status}
                onClick={() => handleFilterSelect(status)}
                selected={activeFilter.toLowerCase() === status.toLowerCase()}
                sx={{ fontSize: '0.875rem' }}
              >
                {status}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </Box>

      <Paper
        sx={{
          mb: 3,
          p: 2,
          borderRadius: '18px',
          border: '1px solid #e5e7eb',
          boxShadow: '0 6px 18px rgba(0,0,0,0.05)',
          bgcolor: '#fff',
          overflowX: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            flexWrap: 'nowrap',
            minWidth: 'max-content',
          }}
        >
          <FormControl sx={{ minWidth: 150, flexShrink: 0 }} size="small">
            <InputLabel>Passed Out Year</InputLabel>
            <Select
              multiple
              value={passedOutYearFilter}
              onChange={handleMultiSelectChange(setPassedOutYearFilter)}
              input={<OutlinedInput label="Passed Out Year" />}
              renderValue={(selected) =>
                selected.length ? selected.join(', ') : 'All Years'
              }
            >
              {passedOutYearOptions.map((year) => (
                <MenuItem key={year} value={year}>
                  <Checkbox checked={passedOutYearFilter.indexOf(year) > -1} />
                  <ListItemText primary={year} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl sx={{ minWidth: 150, flexShrink: 0 }} size="small">
            <InputLabel>Experience</InputLabel>
            <Select
              multiple
              value={experienceFilter}
              onChange={handleMultiSelectChange(setExperienceFilter)}
              input={<OutlinedInput label="Experience" />}
              renderValue={(selected) =>
                selected.length ? selected.join(', ') : 'All Experience'
              }
            >
              {experienceOptions.map((item) => (
                <MenuItem key={item} value={item}>
                  <Checkbox checked={experienceFilter.indexOf(item) > -1} />
                  <ListItemText primary={item} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl sx={{ minWidth: 150, flexShrink: 0 }} size="small">
            <InputLabel>Skills</InputLabel>
            <Select
              multiple
              value={skillsFilter}
              onChange={handleMultiSelectChange(setSkillsFilter)}
              input={<OutlinedInput label="Skills" />}
              renderValue={(selected) =>
                selected.length ? selected.join(', ') : 'All Skills'
              }
            >
              {skillOptions.map((item) => (
                <MenuItem key={item} value={item}>
                  <Checkbox checked={skillsFilter.indexOf(item) > -1} />
                  <ListItemText primary={item} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl sx={{ minWidth: 150, flexShrink: 0 }} size="small">
            <InputLabel>Education</InputLabel>
            <Select
              multiple
              value={educationFilter}
              onChange={handleMultiSelectChange(setEducationFilter)}
              input={<OutlinedInput label="Education" />}
              renderValue={(selected) =>
                selected.length ? selected.join(', ') : 'All Education'
              }
            >
              {educationOptions.map((item) => (
                <MenuItem key={item} value={item}>
                  <Checkbox checked={educationFilter.indexOf(item) > -1} />
                  <ListItemText primary={item} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl sx={{ minWidth: 150, flexShrink: 0 }} size="small">
            <InputLabel>Job Applied</InputLabel>
            <Select
              multiple
              value={jobAppliedFilter}
              onChange={handleMultiSelectChange(setJobAppliedFilter)}
              input={<OutlinedInput label="Job Applied" />}
              renderValue={(selected) =>
                selected.length ? selected.join(', ') : 'All Jobs'
              }
            >
              {jobAppliedOptions.map((item) => (
                <MenuItem key={item} value={item}>
                  <Checkbox checked={jobAppliedFilter.indexOf(item) > -1} />
                  <ListItemText primary={item} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            variant="text"
            onClick={clearAdvancedFilters}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              ml: 1,
            }}
          >
            Clear All
          </Button>
          <Button
            variant="contained"
            sx={{
              textTransform: 'none',
              fontWeight: 'bold',
              borderRadius: '8px',
              px: 3,
              height: '40px',
              bgcolor: '#4F46E5',
              '&:hover': { bgcolor: '#4338CA' },
            }}
          >
            Apply Filters
          </Button>
        </Box>
      </Paper>


      <TableContainer component={Paper} sx={{ boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', border: '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden' }}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead sx={{ bgcolor: '#f8f9fa' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', color: '#111827', py: 2 }}>Candidate Name</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#111827', py: 2 }}>Email</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#111827', py: 2 }}>Job Title</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#111827', py: 2 }}>Applied On</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#111827', py: 2 }}>Status</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#111827', py: 2 }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedApps.map((app) => {
              const statusStyle = getStatusColor(app.status);
              const fullName = `${app.first_name} ${app.last_name}`;
              return (
                <TableRow key={app.id} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell sx={{ py: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Avatar
                        sx={{
                          width: 36,
                          height: 36,
                          fontSize: '0.875rem',
                          fontWeight: 600,
                          bgcolor: getAvatarColor(fullName)
                        }}
                      >
                        {getInitials(app.first_name, app.last_name)}
                      </Avatar>
                      <Typography sx={{ fontWeight: 600, color: '#111827', fontSize: '0.95rem' }}>
                        {fullName}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell sx={{ color: '#111827', fontSize: '0.875rem' }}>{app.email}</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#111827', fontSize: '0.875rem' }}>
                      <WorkIcon sx={{ fontSize: 16, color: '#111827' }} />
                      {app.job_title || job?.title || 'N/A'}
                    </Box>
                  </TableCell>
                  <TableCell sx={{ color: '#111827', fontSize: '0.875rem' }}>
                    {new Date(app.created_at).toLocaleDateString('en-GB')}
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={formatStatus(app.status)}
                      size="small"
                      sx={{
                        bgcolor: statusStyle.bg,
                        color: statusStyle.text,
                        fontWeight: 500,
                        fontSize: '0.75rem',
                        borderRadius: '6px',
                        px: 0.5
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<Visibility sx={{ fontSize: 18 }} />}
                      onClick={() => navigate(`/admin/applications/${app.id}`)}
                      sx={{
                        textTransform: 'none',
                        fontWeight: 'bold',
                        color: '#4F46E5',
                        borderColor: '#4F46E5',
                        borderRadius: '8px',
                        '&:hover': { borderColor: '#4338CA', bgcolor: 'rgba(79,70,229,0.04)' }
                      }}
                    >
                      View Details
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        {displayedApps.length === 0 && (
          <Box sx={{ py: 4, textAlign: 'center' }}>
            <Typography color="text.secondary">No applications found</Typography>
          </Box>
        )}
      </TableContainer>

      <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <Typography sx={{ color: '#718096', fontSize: '0.875rem' }}>
          {totalApplications === 0
            ? 'Showing 0 to 0 of 0 applications'
            : `Showing ${(page - 1) * 50 + 1} to ${Math.min(page * 50, totalApplications)} of ${totalApplications} applications`}
        </Typography>

        {totalPages > 1 && (
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              size="small"
              disabled={page === 1}
              onClick={() => setPage(p => p - 1)}
              sx={{ minWidth: 32, height: 32, p: 0, border: '1px solid #e2e8f0', borderRadius: '6px', color: '#4a5568' }}
            >
              <NavigateBefore fontSize="small" />
            </Button>

            {[...Array(totalPages)].map((_, i) => (
              <Button
                key={i}
                size="small"
                onClick={() => setPage(i + 1)}
                sx={{
                  minWidth: 32,
                  height: 32,
                  p: 0,
                  borderRadius: '6px',
                  bgcolor: page === i + 1 ? '#00695c' : 'transparent',
                  color: page === i + 1 ? 'white' : '#4a5568',
                  border: page === i + 1 ? 'none' : '1px solid #e2e8f0',
                  '&:hover': { bgcolor: page === i + 1 ? '#004d40' : '#f7fafc' }
                }}
              >
                {i + 1}
              </Button>
            ))}

            <Button
              size="small"
              disabled={page === totalPages}
              onClick={() => setPage(p => p + 1)}
              sx={{ minWidth: 32, height: 32, p: 0, border: '1px solid #e2e8f0', borderRadius: '6px', color: '#4a5568' }}
            >
              <NavigateNext fontSize="small" />
            </Button>
          </Box>
        )}
      </Box>
    </Container>
  );
}

export default JobApplications;
